import { render, staticRenderFns } from "./AddDocumentType.vue?vue&type=template&id=359fe1c6&"
import script from "./AddDocumentType.vue?vue&type=script&lang=js&"
export * from "./AddDocumentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports